/* ============================================================
   OFF MARC — theme interactions (ported from the storefront/v2 preview).
   Cart uses Shopify's AJAX API; the drawer re-renders via section rendering.
   ============================================================ */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const OM = window.OM || {};
  const R = OM.routes || {};
  const root = (R.root || '/').replace(/\/$/, '');
  const esc = s => String(s ?? '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const scrim = $('[data-scrim]');
  const hdr = $('[data-hdr]');

  // Shopify money formats ({{amount}}, {{amount_no_decimals}}, …) — matches the Liquid money filter
  function money(cents) {
    const fmt = OM.money || '{{amount}}', n = cents / 100;
    const fix = (d, th = ',', dec = '.') => { const [i, f] = n.toFixed(d).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (d ? dec + f : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: fix(2), amount_no_decimals: fix(0),
      amount_with_comma_separator: fix(2, '.', ','), amount_no_decimals_with_comma_separator: fix(0, '.', ','),
    }[k] ?? fix(2)));
  }

  /* ---------- panels: cart drawer / mobile menu / search ---------- */
  const panel = n => ({ cart: $('[data-cart]'), mobile: $('[data-mnav]'), search: $('[data-search]') })[n];
  function open(n) {
    const p = panel(n); if (!p) return false;
    close(); p.classList.add('is-open'); scrim?.classList.add('is-open');
    if (n === 'search') setTimeout(() => $('[data-search] input[name="q"]')?.focus(), 60);
    return true;
  }
  function close() { ['cart', 'mobile', 'search'].forEach(n => panel(n)?.classList.remove('is-open')); scrim?.classList.remove('is-open'); }
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-open]');
    if (o && open(o.dataset.open)) e.preventDefault();   // the Bag link falls back to /cart if there's no drawer
    if (e.target.closest('[data-close]') || e.target === scrim) close();
  });

  /* ---------- mega menu (hover/focus, built from the store's nested menu) ---------- */
  const ms = $('[data-mega-scrim]');
  let tOpen, tClose;
  function mega(id) {
    clearTimeout(tClose);
    $$('.mega').forEach(m => m.classList.toggle('is-open', m.dataset.mega === id));
    $$('[data-mega-trigger]').forEach(t => t.setAttribute('aria-expanded', String(t.dataset.megaTrigger === id)));
    ms?.classList.toggle('is-open', !!id);
  }
  const later = () => { tClose = setTimeout(() => mega(null), 140); };
  $$('[data-mega-trigger]').forEach(t => {
    t.addEventListener('mouseenter', () => { clearTimeout(tClose); tOpen = setTimeout(() => mega(t.dataset.megaTrigger), 100); });
    t.addEventListener('mouseleave', () => { clearTimeout(tOpen); later(); });
    t.addEventListener('focus', () => mega(t.dataset.megaTrigger));
  });
  $$('.mega').forEach(m => { m.addEventListener('mouseenter', () => clearTimeout(tClose)); m.addEventListener('mouseleave', later); });
  ms?.addEventListener('mouseenter', () => mega(null));
  addEventListener('keydown', e => { if (e.key === 'Escape') { close(); mega(null); } });

  /* ---------- header: fold the menu into the burger when it can't fit beside the centred logo ---------- */
  const navEl = $('.nav'), leftEl = $('.hdr__left');
  // 1) links fit beside the logo → one row; 2) else a second row under the logo;
  // 3) else (narrow screens) the burger. Then publish the real header height.
  function fitNav() {
    if (!hdr || !navEl || !leftEl) return;
    hdr.classList.remove('hdr--compact', 'hdr--wrap');
    if (getComputedStyle(navEl).display !== 'none' && navEl.scrollWidth > leftEl.clientWidth + 1) {
      hdr.classList.add('hdr--wrap');
      if (navEl.scrollWidth > leftEl.clientWidth + 1) { hdr.classList.remove('hdr--wrap'); hdr.classList.add('hdr--compact'); }
    }
    document.documentElement.style.setProperty('--hdr-h', hdr.offsetHeight + 'px');
  }
  fitNav(); addEventListener('resize', fitNav); document.fonts?.ready.then(fitNav);


  /* Predictive search with cancellation so old responses cannot replace a new query. */
  const searchInput = document.querySelector('#SearchQ'), suggestions = document.querySelector('#SearchSuggestions');
  let searchTimer, searchController;
  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer); searchController?.abort(); suggestions.replaceChildren();
    const q = searchInput.value.trim(); if(q.length < 2) return;
    searchTimer = setTimeout(async () => {
      const controller = new AbortController(); searchController = controller;
      const all = document.createElement('a'); all.href = `${root}/search?q=${encodeURIComponent(q)}&type=product`; all.textContent = `View all results for “${q}”`;
      try {
        const response = await fetch(`${root}/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,collection&resources[limit]=6`, {signal:controller.signal});
        if(!response.ok) throw new Error('Search unavailable');
        const data = await response.json(); if(searchInput.value.trim() !== q) return;
        const results = data.resources?.results || {};
        for(const item of [...(results.collections || []), ...(results.products || [])]) {
          const link = document.createElement('a'); link.href = item.url;
          const src = typeof item.image === 'string' ? item.image : item.featured_image?.url;
          if(src){const image=document.createElement('img');image.src=src;image.alt='';link.append(image);}
          const title=document.createElement('span');title.textContent=item.title;link.append(title);suggestions.append(link);
        }
      } catch(e) {if(e.name === 'AbortError') return;}
      if(searchInput.value.trim() === q) suggestions.append(all);
    },220);
  });

  /* ---------- cart ---------- */
  async function refreshCart(openAfter) {
    try {
      const [secs, cart] = await Promise.all([
        fetch(`${root}/?sections=cart-drawer`).then(r => r.json()),
        fetch(`${R.cart}.js`).then(r => r.json()),
      ]);
      const fresh = new DOMParser().parseFromString(secs['cart-drawer'] || '', 'text/html').querySelector('[data-cart]');
      const cur = $('[data-cart]');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      $$('[data-count]').forEach(el => { el.textContent = cart.item_count; });
      if (openAfter) open('cart');
    } catch { location.href = R.cart; }
  }
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-line]'); if (!b || b.disabled) return;
    e.preventDefault(); b.disabled = true;
    try {
    const response = await fetch(`${R.cart_change}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: +b.dataset.line, quantity: +b.dataset.qty }) });
    if (!response.ok) { const data = await response.json(); throw new Error(data.description || 'Unable to update quantity.'); }
    if (document.body.classList.contains('template-cart')) location.reload(); else await refreshCart();
    } catch (err) { let msg = $('[data-cart-error]'); if (!msg) { msg = document.createElement('p'); msg.dataset.cartError = ''; msg.setAttribute('role','alert'); b.closest('.line')?.append(msg); } msg.textContent = err.message || 'Please check your connection and try again.'; b.disabled = false; }
  });
  document.addEventListener('submit', async e => {
    const f = e.target.closest('form[data-product-form]'); if (!f) return;
    e.preventDefault();
    const btn = f.querySelector('[type="submit"]'), msg = f.querySelector('[data-msg]'), id = f.querySelector('input[name="id"]');
    if (msg) msg.textContent = '';
    if (!id || !id.value) {                      // a size hasn't been picked yet
      if (msg) msg.textContent = f.dataset.need || 'Select a size';
      $('[data-opt]')?.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 240 });
      return;
    }
    btn.disabled = true;
    try {
    const res = await fetch(`${R.cart_add}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) });
    const data = await res.json().catch(() => ({}));
    btn.disabled = false;
    if (!res.ok) { if (msg) msg.textContent = data.description || data.message || 'Could not add to bag.'; return; }
    await refreshCart(true);
    } catch { if (msg) msg.textContent = 'Connection interrupted. Check your bag before trying again.'; } finally { btn.disabled = false; }
  });

  /* ---------- variant picker ---------- */
  $$('[data-product]').forEach(rootEl => {
    const json = rootEl.querySelector('[data-product-json]'); if (!json) return;
    const data = JSON.parse(json.textContent);
    const form = rootEl.querySelector('form[data-product-form]');
    const idInput = form?.querySelector('input[name="id"]'), btn = form?.querySelector('[data-add]');
    const price = rootEl.querySelector('[data-price]');
    const groups = $$('[data-opt]', rootEl);
    const sel = () => groups.map(g => g.querySelector('[aria-checked="true"]')?.dataset.value ?? null);
    function sync(fromClick) {
      const s = sel();
      groups.forEach((g, gi) => $$('[data-value]', g).forEach(b => {
        const ok = data.variants.some(v => v.available && v.options[gi] === b.dataset.value && v.options.every((o, i) => i === gi || s[i] == null || o === s[i]));
        b.classList.toggle('is-unavailable', !ok);
      }));
      if (!form) return;
      if (s.includes(null)) { idInput.value = ''; btn.disabled = false; btn.textContent = btn.dataset.add || 'Add to bag'; return; }
      const v = groups.length === 0 && data.variants.length === 1
        ? data.variants[0]
        : data.variants.find(v => v.options.every((o, i) => o === s[i]));
      if (!v) { idInput.value = ''; btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      btn.disabled = !v.available; btn.textContent = v.available ? (btn.dataset.add || 'Add to bag') : 'Sold out';
      if (price) price.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ` <s>${money(v.compare_at_price)}</s>` : '');
      if (fromClick) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
    }
    groups.forEach(g => g.addEventListener('click', e => {
      const b = e.target.closest('[data-value]'); if (!b) return;
      $$('[data-value]', g).forEach(x => x.setAttribute('aria-checked', String(x === b)));
      const lbl = g.querySelector('[data-sel]'); if (lbl) lbl.textContent = b.dataset.value;
      sync(true);
    }));
    sync(false);
  });






  /* ---------- PDP: selectable dispatch windows ---------- */
  $$('[data-product]').forEach(rootEl => {
    const node = rootEl.querySelector('[data-delivery-json]');
    if (!node) return;
    const productNode = rootEl.querySelector('[data-product-json]');
    let productData = { variants: [] };
    try { productData = JSON.parse(productNode?.textContent || '{}') || productData; } catch {}
    let deliveryData = {};
    try { deliveryData = JSON.parse(node.textContent || '{}') || {}; } catch {}
    const timeline = rootEl.querySelector('[data-delivery-timeline]');
    if (!timeline) return;
    const labels = { express: '1–3 days', standard: '7–12 days', eta: '14–21 days', fallback: '18–24 days' };
    const modeOrder = ['express', 'standard', 'eta', 'fallback'];
    const dispatch = timeline.querySelector('[data-dispatch-window]');
    const badge = timeline.querySelector('[data-delivery-badge]');
    const detail = timeline.querySelector('[data-delivery-detail]');
    const picker = timeline.querySelector('[data-dispatch-picker]');
    const optionsBox = timeline.querySelector('[data-dispatch-options]');
    const modes = Array.isArray(deliveryData.windows) ? deliveryData.windows.filter(m => labels[m]) : [];
    const variantModes = deliveryData.variants || {};
    const selectedModes = new Map();
    const closePicker = () => {
      if (!picker || !optionsBox) return;
      picker.setAttribute('aria-expanded', 'false');
      optionsBox.hidden = true;
    };
    const availableFor = variant => {
      if (!variant) return [];
      const raw = variantModes[String(variant.id)];
      const values = Array.isArray(raw) ? raw : (raw ? [raw] : []);
      return modeOrder.filter(mode => values.includes(mode));
    };
    const renderChoices = (variant, supported) => {
      if (!optionsBox) return;
      optionsBox.replaceChildren();
      modeOrder.forEach(mode => {
        const row = document.createElement('button');
        row.type = 'button';
        row.className = 'delivery-timeline__option';
        const text = document.createElement('span');
        text.textContent = labels[mode];
        const status = document.createElement('small');
        status.textContent = !variant ? (modes.includes(mode) ? 'Choose a size' : 'Not listed') : (supported.includes(mode) ? 'Available' : 'Unavailable for this size');
        row.append(text, status);
        row.disabled = !variant || variant.available === false || !supported.includes(mode);
        row.setAttribute('aria-pressed', String(!!variant && selectedModes.get(String(variant.id)) === mode));
        if (!row.disabled) row.addEventListener('click', () => {
          selectedModes.set(String(variant.id), mode);
          updateTimeline(variant);
          closePicker();
          picker?.focus();
        });
        optionsBox.append(row);
      });
    };
    const updateTimeline = variant => {
      const supported = availableFor(variant);
      if (!variant) {
        const sizeModes = modeOrder.filter(mode => modes.includes(mode));
        dispatch.textContent = sizeModes.length === 1 ? labels[sizeModes[0]] : (sizeModes.length ? 'Choose a size' : 'Confirm with OFFMARC');
        badge.textContent = sizeModes.length ? 'SELECT A SIZE' : 'TIMING TO CONFIRM';
        detail.textContent = sizeModes.length ? 'Choose a size, then open dispatch to check the timing available for it.' : 'We do not have a verified dispatch window for this listing yet. Please contact OFFMARC before ordering.';
        renderChoices(null, []);
        return;
      }
      const size = variant.options?.find(Boolean) || (variant.title === 'Default Title' ? 'One Size' : variant.title);
      if (variant.available === false) {
        dispatch.textContent = 'Unavailable';
        badge.textContent = 'SIZE SOLD OUT';
        detail.textContent = `${size} is not currently available.`;
        renderChoices(variant, []);
        return;
      }
      if (!supported.length) {
        dispatch.textContent = 'Confirm with OFFMARC';
        badge.textContent = size.toUpperCase();
        detail.textContent = `No verified dispatch window is on file for ${size}. Please contact OFFMARC before ordering.`;
        renderChoices(variant, []);
        return;
      }
      let selected = selectedModes.get(String(variant.id));
      if (!supported.includes(selected)) selected = supported[supported.length - 1];
      selectedModes.set(String(variant.id), selected);
      dispatch.textContent = labels[selected];
      badge.textContent = supported.length > 1 ? `${supported.length} WINDOWS · ${size.toUpperCase()}` : size.toUpperCase();
      detail.textContent = supported.length > 1 ? `Estimated dispatch for ${size}: ${labels[selected]}. Open dispatch to choose another available window.` : `Estimated dispatch for ${size}: ${labels[selected]}${selected === 'fallback' ? ' (extended sourcing estimate)' : ''}.`;
      renderChoices(variant, supported);
    };
    picker?.addEventListener('click', () => {
      const open = picker.getAttribute('aria-expanded') === 'true';
      picker.setAttribute('aria-expanded', String(!open));
      optionsBox.hidden = open;
      if (!open) requestAnimationFrame(() => optionsBox.scrollIntoView({ block: 'nearest', inline: 'nearest' }));
    });
    document.addEventListener('click', event => { if (!timeline.contains(event.target)) closePicker(); });
    picker?.addEventListener('keydown', event => { if (event.key === 'Escape') closePicker(); });
    const groups = $$('[data-opt]', rootEl);
    const selectedVariant = () => {
      if (!groups.length) return productData.variants?.[0] || null;
      const options = groups.map(g => g.querySelector('[aria-checked="true"]')?.dataset.value ?? null);
      if (options.includes(null)) return null;
      return productData.variants?.find(v => v.options.every((option, i) => option === options[i])) || null;
    };
    groups.forEach(group => group.addEventListener('click', () => {
      closePicker();
      updateTimeline(selectedVariant());
    }));
    updateTimeline(selectedVariant());
  });

  /* ---------- PDP: delivery / returns tabs ---------- */
  $$('[data-dtabs]').forEach(w => w.addEventListener('click', e => {
    const b = e.target.closest('[data-dt]'); if (!b) return;
    $$('[data-dt]', w).forEach(x => x.setAttribute('aria-selected', String(x === b)));
    $$('[data-dp]', w.parentElement).forEach(d => { d.hidden = d.dataset.dp !== b.dataset.dt; });
  }));

  /* ---------- PDP: "2 / 5" counter on the phone swipe gallery ---------- */
  $$('[data-gal]').forEach(g => {
    const c = g.parentElement.querySelector('[data-galcount]'), n = g.children.length; if (!c) return;
    g.addEventListener('scroll', () => { c.textContent = `${Math.round(g.scrollLeft / g.clientWidth) + 1} / ${n}`; }, { passive: true });
  });

  /* ---------- homepage: collection tabs ---------- */
  $$('[data-tabs]').forEach(t => {
    const btns = $$('[role="tab"]', t), panes = $$('[role="tabpanel"]', t);
    btns.forEach(b => b.addEventListener('click', () => {
      btns.forEach(x => x.setAttribute('aria-selected', String(x === b)));
      panes.forEach(p => { p.hidden = p.id !== b.getAttribute('aria-controls'); });
    }));
  });

  /* ---------- hero: horizontal swipe carousel, seamless loop via edge clones ---------- */
  $$('[data-fhero]').forEach(fh => {
    const track = $('[data-track]', fh), real = $$('.fslide', track), dots = $$('.fdot', fh), n = real.length;
    const dwell = +fh.dataset.dwell || 7000;
    if (n < 2) { $('.fhero__nav', fh)?.remove(); real[0]?.querySelector('video')?.play().catch(() => {}); return; }
    const lastClone = real[n - 1].cloneNode(true), firstClone = real[0].cloneNode(true);
    track.appendChild(firstClone); track.insertBefore(lastClone, real[0]);
    [firstClone, lastClone].forEach(c => { c.setAttribute('aria-hidden', 'true'); c.inert = true; $$('video', c).forEach(v => { v.removeAttribute('autoplay'); v.pause(); }); });
    let pos = 1, animating = false, timer;
    const realIndex = () => ((pos - 1) % n + n) % n;
    const setX = anim => { track.classList.toggle('no-anim', !anim); track.style.transform = `translateX(${-pos * 100}%)`; };
    const syncDots = () => dots.forEach((d, i) => d.classList.toggle('is-active', i === realIndex()));
    const playVideo = () => { $$('video', track).forEach(v => v.pause()); const v = track.children[pos]?.querySelector('video'); if (v) { try { v.currentTime = 0; } catch {} v.play().catch(() => {}); } };
    const schedule = () => { clearTimeout(timer); timer = setTimeout(() => move(1), +real[realIndex()].dataset.dwell || dwell); };
    const move = dir => { if (animating) return; animating = true; pos += dir; setX(true); syncDots(); };
    track.addEventListener('transitionend', e => {
      if (e.target !== track || e.propertyName !== 'transform') return;
      animating = false;
      if (pos === n + 1) { pos = 1; setX(false); } else if (pos === 0) { pos = n; setX(false); }
      playVideo(); schedule();
    });
    dots.forEach((d, i) => d.addEventListener('click', () => { if (animating || i === realIndex()) return; animating = true; pos = i + 1; setX(true); syncDots(); }));
    $('[data-next]', fh)?.addEventListener('click', () => move(1));
    $('[data-prev]', fh)?.addEventListener('click', () => move(-1));
    fh.addEventListener('mouseenter', () => clearTimeout(timer));
    fh.addEventListener('mouseleave', schedule);
    fh.addEventListener('focusin', () => clearTimeout(timer));
    fh.addEventListener('focusout', e => { if (!fh.contains(e.relatedTarget)) schedule(); });
    let x0 = null;
    fh.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
    fh.addEventListener('touchend', e => { if (x0 == null) return; const dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) move(dx < 0 ? 1 : -1); x0 = null; });
    setX(false); syncDots(); playVideo(); schedule();
  });

  /* ---------- collection: sort + phone filter panel ---------- */
  $$('[data-sort]').forEach(s => s.addEventListener('change', () => {
    const u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u;
  }));
  $$('[data-filters]').forEach(f => {
    const t = f.querySelector('.filters__toggle');
    t?.addEventListener('click', () => { const o = f.dataset.open !== 'true'; f.dataset.open = String(o); t.setAttribute('aria-expanded', String(o)); });
  });

  /* ---------- footer: country / currency switch ---------- */
  $$('[data-loc] select').forEach(s => s.addEventListener('change', () => s.form.submit()));

  /* ---------- PDP: delivery estimate ("Estimated delivery Wed 22 Oct – Mon 27 Oct").
     Computed here, not in Liquid, so a cached page never shows a stale date. ---------- */
  $$('[data-eta]').forEach(row => {
    const min = +row.dataset.min, max = +row.dataset.max, skipSun = row.dataset.skipSun === 'true';
    if (!(max >= min && min >= 0)) return;
    const add = n => { const d = new Date(); let left = n; while (left > 0) { d.setDate(d.getDate() + 1); if (!(skipSun && d.getDay() === 0)) left--; } return d; };
    const fmt = d => d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
    const out = row.querySelector('[data-eta-out]');
    if (out) out.textContent = min === max ? fmt(add(min)) : `${fmt(add(min))} – ${fmt(add(max))}`;
    row.hidden = false;
  });

  /* ---------- product recommendations (Shopify's own, via section rendering) ---------- */
  $$('[data-recs]').forEach(async el => {
    try {
      const r = await fetch(el.dataset.url); if (!r.ok) return;
      const inner = new DOMParser().parseFromString(await r.text(), 'text/html').querySelector('[data-recs]');
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
    } catch {}
  });

  /* ---------- recently viewed (localStorage handles → /products/<handle>.js) ---------- */
  const KEY = 'om.seen';
  const seen = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; } };
  const here = $('[data-product-handle]')?.dataset.productHandle;
  if (here) { try { localStorage.setItem(KEY, JSON.stringify([here, ...seen().filter(h => h !== here)].slice(0, 12))); } catch {} }
  const sized = (src, w) => src ? `${src.startsWith('//') ? 'https:' + src : src}${src.includes('?') ? '&' : '?'}width=${w}` : '';
  const card = p => {
    const img = p.featured_image, img2 = p.images && p.images[1];
    const cmp = p.compare_at_price > p.price ? ` <s>${money(p.compare_at_price)}</s>` : '';
    return `<a class="pc" href="${root}/products/${esc(p.handle)}">
      <div class="pc__img">${img ? `<img src="${esc(sized(img, 600))}" alt="${esc(p.title)}" loading="lazy">` : ''}${img2 ? `<img src="${esc(sized(img2, 600))}" alt="" loading="lazy">` : ''}</div>
      <div class="pc__body">${OM.badge ? `<span class="pc__badge">${esc(OM.badge)}</span>` : ''}<span class="pc__name">${esc(p.title)}</span>
      <span class="pc__cat">${esc(p.vendor)}${p.type ? ' · ' + esc(p.type) : ''}</span>
      <span class="pc__price">${p.available ? (p.price_varies ? 'From ' : '') + money(p.price) + cmp : 'Sold out'}</span></div></a>`;
  };
  $$('[data-recently]').forEach(async box => {
    const list = seen().filter(h => h !== here).slice(0, +box.dataset.limit || 8); if (!list.length) return;
    const prods = (await Promise.all(list.map(h => fetch(`${root}/products/${encodeURIComponent(h)}.js`).then(r => (r.ok ? r.json() : null)).catch(() => null)))).filter(Boolean);
    if (!prods.length) return;
    box.querySelector('[data-rv-rail]').innerHTML = prods.map(card).join('');
    box.hidden = false;
  });
})();
